export default "__VITE_ASSET__DQ66hPT7__"